<template>
	<div id="breadcrumb" class="text_light">
		<div
		class="breadCrumb_item loop" 
		v-for="(path, pathIndex) in getBreadCrumb()" v-bind:key="pathIndex"
		v-bind:class=" [pathIndex == 0 && breadCrumbLength >= 2 ? 'highlight' : null,
		pathIndex == breadCrumbLength - 1 ? 'lastmobile' : '' ]">
			<div class="breadcrumb_title"
			v-on:click="moveToNode(path)">{{path.title}}</div>
			<div class="breadcrumb_arrow"></div>
		</div>
		<div
		class="breadCrumb_item current highlight disabled" 
		>
			<div class="breadcrumb_title" v-html="App.getCurrentTitle()"></div>
			<div class="breadcrumb_arrow hidden"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BreadCrumbs',
	props: {
		App: Object
	},
	data : function() {
		return {
			breadCrumbLength: 0
		}
	},
	mounted() {
	},
	created() {
	},
	methods : {

		moveToNode(node) {
			this.App.nextNode = node;
			document.dispatchEvent(this.App.events.moveToNextNode);
		},

		getParentOfNode(node, nodeIter, parentNodeRes) {
			nodeIter.children.forEach( (childNode) => {
				parentNodeRes.iterations++;
				if (childNode.id == node.id) {
					parentNodeRes.result = nodeIter;
					return;
				}
				else {
					this.getParentOfNode(node, childNode, parentNodeRes);
				}
			})
		},

		getParentOfNodeBegin(nodeCurrent, nodeIter, parentNodeResult) {
			this.App.room.hierarchy.forEach((childNode) => { 
				
				this.getParentOfNode(nodeCurrent, childNode, parentNodeResult)
			})
		},
		

		getBreadCrumb() {

			if(this.App.currentNode == null || this.App.currentNode.type == 0) 
				return []
			
			var output = {
				path: [],
				beginReached: false
			}

			var nodeCurrent = this.App.currentNode;

			while(!output.beginReached) {
				
				var parentNodeResult = {result : null, iterations: 0}

				this.getParentOfNodeBegin(nodeCurrent, nodeCurrent, parentNodeResult);

				if(parentNodeResult.result != null) {
					output.path.push(parentNodeResult.result)

					if(parentNodeResult.result.type == 0)
						output.beginReached = true;
					else {
						nodeCurrent = parentNodeResult.result
					}
				}
				else {
					output.beginReached = true;
				}
			}

			this.breadCrumbLength = output.path.length;
			return output.path.reverse();
		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
